import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Subtle top-of-page progress bar that animates whenever any axios call is in
 * flight. Two key UX wins:
 *  - the user always sees the app responding the moment they click
 *  - the bar smoothly retracts when the last request resolves
 *
 *  Mounts globally in DashboardLayout.
 */
export default function GlobalProgress() {
  const [inflight, setInflight] = useState(0);

  useEffect(() => {
    const reqId = api.interceptors.request.use((cfg) => {
      setInflight((n) => n + 1);
      return cfg;
    });
    const handleResp = (resp) => {
      setInflight((n) => Math.max(0, n - 1));
      return resp;
    };
    const handleErr = (err) => {
      setInflight((n) => Math.max(0, n - 1));
      return Promise.reject(err);
    };
    const respId = api.interceptors.response.use(handleResp, handleErr);
    return () => {
      api.interceptors.request.eject(reqId);
      api.interceptors.response.eject(respId);
    };
  }, []);

  const active = inflight > 0;

  return (
    <div className="fixed top-0 left-0 right-0 z-[200] h-0.5 pointer-events-none" aria-hidden>
      <div
        className="h-full bg-gradient-to-r from-[#C9A356] via-[#DDBD77] to-[#C9A356] transition-all duration-300 ease-out"
        style={{
          width: active ? "85%" : "0%",
          opacity: active ? 1 : 0,
          boxShadow: active ? "0 0 8px rgba(201, 163, 86, 0.6)" : "none",
          transitionDuration: active ? "1.5s" : "300ms",
        }}
      />
    </div>
  );
}
